const STATUS_DISPLAY = {
  [null]: { class: 'grey--text', msg: 'Not subscribed' },
  EXPIRED: { class: 'grey--text', msg: 'Expired', datePrefix: 'Expired' },
  EXPIRED_ERR: { class: 'error--text', msg: 'Inactive', datePrefix: 'Renewal failed' },
  ACTIVE: { class: 'success--text', msg: 'Active', datePrefix: 'Renews' },
  ACTIVE_CANCELLED: { class: 'warning--text', msg: 'Cancelled', datePrefix: 'Discount expires' }
};

function getStatus(s) {
  if (!s)
    return null;
  if (!s.next_at || (new Date(s.next_at) < new Date()))
    // There may be a 'payment_failed_msg'
    return s.payment_failed_msg ? 'EXPIRED_ERR' : 'EXPIRED';
  if (s.cancelled_at)
    // This subscription is still valid until the 'next_at' date
    return 'ACTIVE_CANCELLED';
  return 'ACTIVE';
}

export { STATUS_DISPLAY, getStatus };
